module.exports = __webpack_public_path__ + "static/scale-model-of-children's-fairyland-in-oakland-california-15c4fd8c640576e7c687a8356f5d301a.png";